var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6085",
    "data-name": "Group 6085",
    transform: "translate(-1404.102 -256.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    transform: "translate(1408.102 260.102)",
    fill: "#8da2f9",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Camera",
    "data-name": "Iconly/Bold/Camera",
    transform: "translate(1417.102 270.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Camera-2",
    "data-name": "Camera",
    d: "M12.512,14H3.488A3.443,3.443,0,0,1,0,10.613V6A3.443,3.443,0,0,1,3.488,2.61a.159.159,0,0,0,.153-.093l.048-.093.066-.136c.209-.428.445-.912.589-1.192A1.951,1.951,0,0,1,6.112,0H9.88a1.957,1.957,0,0,1,1.776,1.1c.126.245.317.638.5,1.017l.114.233.081.171a.181.181,0,0,0,.16.093A3.443,3.443,0,0,1,16,6v4.615A3.443,3.443,0,0,1,12.512,14ZM8,4.98a3.183,3.183,0,0,0-2.232.9,2.966,2.966,0,0,0-.912,2.152,3.019,3.019,0,0,0,.92,2.16A3.2,3.2,0,0,0,8,11.087a3.162,3.162,0,0,0,2.216-.893,2.986,2.986,0,0,0,.008-4.32A3.17,3.17,0,0,0,8,4.98Zm4.488-.186a.7.7,0,1,0,.729.707A.714.714,0,0,0,12.488,4.794ZM8,9.921A1.96,1.96,0,0,1,6.624,9.37a1.848,1.848,0,0,1-.568-1.336V8.025A1.792,1.792,0,0,1,6.616,6.7,1.992,1.992,0,0,1,9.376,6.7a1.851,1.851,0,0,1,.568,1.336A1.929,1.929,0,0,1,8,9.921Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPCameraIcon);
export default __webpack_public_path__ + "static/media/p_cameraIcon.fc179334e8fe7c2d25e50f8bd4802bbc.svg";
export { ForwardRef as ReactComponent };